export const appVersion = '087fec64bd00';